import {
    validPropFileVM,
    FILE_SIZE_MIN_DEFAULT,
    FILE_SIZE_MAX_MEDIUM,
} from '../../../core/components/validation/ValidInputFile';
import { PayorImportState } from './payor_list_types';

export function payorImportStateVM(): PayorImportState {
    return {
        showing: false,
        confirming: false,
        importing: false,
        ImportFile: validPropFileVM('File', 'Upload Payor File (.txt or .csv, pipe-delimited)', ['.csv', '.txt'], {
            min: FILE_SIZE_MIN_DEFAULT,
            max: FILE_SIZE_MAX_MEDIUM,
        }),
    };
}
